import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { getCachedApiUrl } from '../config/apiConfig';
import './Login.css';

function Login({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsLoading(true);
    
    try {      const formData = new URLSearchParams();
      formData.append('username', email); // OAuth2 expects 'username'
      formData.append('password', password);

      const API_BASE_URL = await getCachedApiUrl();
      const response = await axios.post(`${API_BASE_URL}/token`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        setIsAuthenticated(true);
      }
    } catch (error) {
      setError(error.response?.data?.detail || 'Invalid email or password');
    } finally {
      setIsLoading(false);
    }
  };  return (
    <div className="auth-main">
      <div className="auth-wrapper v1">
        <div className="auth-content">
          <div className="auth-bg">
            <span className="r"></span>
            <span className="r s"></span>
            <span className="r s"></span>
            <span className="r"></span>
          </div>          <div className="auth-form">
            <div className="card">
              <div className="card-body text-center">
                {/* Logo */}
                <div className="mb-4">
                  <img src="/assets/images/RapidCMCLogo.jpeg" alt="RapidCMC" style={{ height: '48px', maxWidth: '200px', objectFit: 'contain' }} />
                  <h4 className="text-primary mt-2 mb-0">RapidCMC</h4>
                  <p className="text-muted">Sign in to your account</p>
                </div>
                
                {error && (
                  <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="feather icon-alert-triangle me-2"></i>
                    <div>{error}</div>
                  </div>
                )}
                
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3 text-start">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={isLoading}
                    />
                  </div>
                  
                  <div className="form-group mb-4 text-start">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={isLoading}
                    />
                  </div>
                  
                  <div className="d-flex mt-1 justify-content-between align-items-center">
                    <div className="form-check">
                      <input className="form-check-input input-primary" type="checkbox" id="customCheckc1" />
                      <label className="form-check-label text-muted" htmlFor="customCheckc1">Remember me</label>
                    </div>
                    <Link to="/forgot-password" className="text-secondary f-14">
                      Forgot Password?
                    </Link>
                  </div>
                  
                  <div className="d-grid mt-4">
                    <button 
                      className="btn btn-primary" 
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Signing In...
                        </>
                      ) : (
                        <>
                          <i className="feather icon-log-in me-2"></i>
                          Sign In
                        </>
                      )}
                    </button>
                  </div>
                </form>
                
                <div className="saprator mt-3">
                  <span>Or continue with</span>
                </div>
                
                <div className="text-center mt-3">
                  <div className="d-grid">
                    <button className="btn btn-outline-dark">
                      <i className="fab fa-google me-2"></i>
                      Sign in with Google
                    </button>
                  </div>
                </div>
                
                <div className="text-center mt-4">
                  <div className="d-inline-flex align-items-center">
                    <i className="feather icon-shield me-2 text-success"></i>
                    <small className="text-muted">Your data is secure and encrypted</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
